<template>
  <div class="modern-form">
    <v-container>
      <PageTabs :tabs="tabs" />
    </v-container>
  </div>
</template>
<script>

import Email from './Messaging/Email.vue';
import SMS from './Messaging/SMS.vue';
import PageTabs from '../components/PageTabs.vue';

export default {
  name: 'MessageLog',
  components: {
    SMS,
    PageTabs,
    Email,
  },
  data() {
    return {
      tabs: [
        { label: 'SMS', section: SMS, access: 'admin' },
        { label: 'Email', section: Email, access: 'user' },
      ],
    };
  },
};
</script>
